import React, { useEffect, useState } from "react";
import TopBar from "../components/TopBar";
import Header from "../components/headerfooter/Header";
import Footer from "../components/headerfooter/Footer";
import CallToAction from "../components/home/CallToAction";
import { getDecryptedData } from "../config/crypto";
import { REACT_APP_API_PORT } from "../Api";
import axios from "axios";
import Loader from "../components/Loader";

const Notifications = () => {
  const [notifications, setNotifications] = useState(
    [
        {
          title: "Welcome to Our Platform!",
          message: "Thanks for signing up. Start exploring today!",
          createdAt: new Date().toISOString(),
        },
        {
          title: "New Feature Released",
          message: "Check out our latest feature update in your dashboard.",
          createdAt: new Date().toISOString(),
        },
        {
          title: "Exclusive Offer",
          message: "Get 20% off on your next purchase. Limited time only!",
          createdAt: new Date().toISOString(),
        },
      ]
  );
  const [apiIsLoading, setApiIsLoading] = useState(false);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        setApiIsLoading(true);
        const token = getDecryptedData("token");

        const res = await axios.get(`${REACT_APP_API_PORT}user/notifications`, {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
        });

        if (res.data.status && res.data.notifications.length > 0) {
          setNotifications(res.data.notifications);
        } else {
          // Use dummy notifications if no real data is available
          setNotifications(
            [
            {
              title: "Welcome to Our Platform!",
              message: "Thanks for signing up. Start exploring today!",
              createdAt: new Date().toISOString(),
            },
            {
              title: "New Feature Released",
              message: "Check out our latest feature update in your dashboard.",
              createdAt: new Date().toISOString(),
            },
            {
              title: "Exclusive Offer",
              message: "Get 20% off on your next purchase. Limited time only!",
              createdAt: new Date().toISOString(),
            },
          ]
        );
        }
      } catch (err) {
        console.error("Error fetching notifications:", err);
      } finally {
        setApiIsLoading(false);
      }
    };

    fetchNotifications();
  }, []);

  return (
    <>
      <Loader isLoading={apiIsLoading} />
      {/* <TopBar /> */}
      <Header />
      <div className="flex justify-center items-center bg-black text-white py-12 px-6">
        <div className="grid border border-gray-500 rounded-xl gap-4 container mx-auto px-6 py-6 max-w-[80rem]">
          <h2 className="text-2xl font-semibold">Notifications</h2>
          {notifications.length > 0 ? (
            <ul className="space-y-4">
              {notifications.map((notification, index) => (
                <li
                  key={index}
                  className="p-4 border border-gray-700 rounded-lg bg-gray-900"
                >
                  <p className="text-lg font-medium">{notification.title}</p>
                  <p className="text-sm text-gray-400">{notification.message}</p>
                  <p className="text-xs text-gray-500 mt-1">
                    {new Date(notification.createdAt).toLocaleString()}
                  </p>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-400">No notifications available.</p>
          )}
        </div>
      </div>
      <CallToAction />
      <Footer />
    </>
  );
};

export default Notifications;
